import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/features/auth/hooks/useAuth';

import { getMyReferral } from '../services/referral.service';

/**
 * The current user's referral code + share link ("Porta un amico").
 */
export function useMyReferral() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ['referral-me'],
    queryFn: getMyReferral,
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 5,
  });
}
